module.exports = {
  // api 开头的配置，需要同步修改/index.js中的线上代理设置
  apiBaseUrl: {
    path: '/api',
    changeOrigin: true,
    target: 'http://swoft-test.knowyourself.cc:8018/',
    pathRewrite: {
      '/api': '/',
    },
  },
  publicPath: {
    path: '/',
  },
  commonApi: {
    path: '/common-api',
    changeOrigin: true,
    target: 'https://common-api-test.knowyourself.cc',
    pathRewrite: {
      '/common-api': '/',
    },
  },
  wechatApi: {
    path: '/wechat-api',
    changeOrigin: true,
    target: 'http://swoft-test.knowyourself.cc:11623',
    pathRewrite: {
      '/wechat-api': '/wechat',
    },
  },
  wxAuthApi: {
    path: '/wx-auth',
    changeOrigin: true,
    target: 'https://wx.knowyourself.cc',
    pathRewrite: {
      '/wx-auth': '/',
    },
  },
  authApi: process.env.NODE_ENV === 'production' ? 'http://ky-account.knowyourself.cc' : 'http://ky-account-test.knowyourself.cc',
  wxDefaultConfig: {
    debug: false,
    jsApiList: [
      'openProductSpecificView',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'onMenuShareQZone',
      'startRecord',
      'stopRecord',
      'onVoiceRecordEnd',
      'playVoice',
      'pauseVoice',
      'stopVoice',
      'onVoicePlayEnd',
      'uploadVoice',
      'downloadVoice',
      'chooseImage',
      'previewImage',
      'uploadImage',
      'downloadImage',
      'translateVoice',
      'getNetworkType',
      'openLocation',
      'getLocation',
      'hideOptionMenu',
      'showOptionMenu',
      'hideMenuItems',
      'showMenuItems',
      'hideAllNonBaseMenuItem',
      'showAllNonBaseMenuItem',
      'closeWindow',
      'scanQRCode',
      'chooseWXPay',
      'addCard',
      'chooseCard',
      'openCard',
    ],
  },
  shareConfig: {
    shareTitle: '知我探索',
    shareText: 'KnowYourself',
    shareImage: 'https://cdn-public.knowyourself.cc/2018/07/02/12/05/34/fbJefWuTYm.png',
  },
}
